var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("h1", [_vm._v("软件许可及服务协议")]),
      _vm._v("\n    总 则\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    在此特别提醒用户认真阅读，充分理解本《软件许可及服务协议》（下称“协议”）。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议约定深圳埃努码信息技术有限公司及关联公司（以下统称“我们”、“埃努码公司”或“Enuma”）与所有用户（包括注册、登录、使用本服务的个人及团队，以下简称“您”）之间，关于我们提供的移动应用程序，教育内容，游戏，相关服务和网站（以下简称为“都都产品与/或服务”）的权利义务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议构成您使用都都产品/或服务的先决条件，请您在使用产品/或服务前仔细阅读本协议的各项条款。我们善意的提醒您，请您认真阅读，充分理解本协议中各条款，本协议中与你你权益（可能）存在重大关系的条款，我们已采用加粗和/或加下划线的方式进行特别提示，请您留意并重点阅读。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议向您提供都都产品与/或服务的通用型用户服务协议。请您审慎阅读并选择接受或不接受本协议（未成年人应在法定监护人或经授权的学校老师陪同下阅读并选择是否同意）。"
      ),
      _c("b", [
        _vm._v(
          "您使用都都产品与/或服务的行为（包括下载，安装，启动、浏览、激活、注册、使用，订阅和注销等行为）（以下简称“使用行为”），表示您同意本协议具体规则，并同意接受本协议及其任何修改版本中各项条款的约束。如果您不愿意接受本协议具体规则的，请您不要使用任何都都产品与/或服务。"
        ),
      ]),
      _vm._v("当您停止使用都都产品与/或服务时，"),
      _c("b", [
        _vm._v("可以通过本协议第1.7条所述方式，联系我们处理相关事宜。"),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您理解并同意，本协议条款和规则可能因国家政策、都都产品本身及履行本协议的环境发生变化等原因，由公司随时更新（包括但不限于修改、替换或升级等），更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。您可以在我们提供的应用程序及网站中查阅最新版协议条款。在修改协议条款后，如果您不接受修改后的条款，请立即停止使用我们提供的服务。您继续使用我们提供的服务，将被视为同意并接受修改后的协议规则。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如您在阅读本协议过程中有任何疑惑或需要咨询其他相关事宜，您可通过本协议第1.7条所述方式联系我们，我们会尽快为您做出解答。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第一章 条款和协议")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们的服务包括且不仅限于：\n    应用程序：都都数学®, 都都英语®, 都都思维®，都都GO®，都都kids®，都都one®，都都家长服务®，都都服务®；\n    网站：enuma.cn，todomath.cn，todokids.cn，todoone.cn;\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.1知识产权声明\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.1.1所有应用程序和网站（以下称“产品“）是由埃努码公司开发并运营。产品相关的一切版权，商标权，专利权，商业机密等知识产权，以及与产品相关的技术、程序、数据及其他信息内容（包括但不限于文字，图标，图像、图片、音频、视频、图表，色彩，界面设计，版面框架，有关数据，印刷材料，电子文档等）均受中华人民共和国著作权法，商标法，专利法，反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护，除涉及第三方授权的软件或技术外，我们享有所有知识产权和相关权益。我们享有的所有知识产权和相关权益，不因您的任何使用行为而发生任何的权利转移。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.1.2未经书面同意，任何盈利性或非营利性的目的，自行实施，利用，转让或许可任何第三方实施，利用，转让上述知识产权（即包括但不限于产品软件的破解，篡改，以及删除、掩盖、更改都都产品形象、视频或商标等），均将认定为对Enuma的侵权行为。我们将追究上述未经许可行为，并保留向未经许可的第三方追溯经济赔偿的权利。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.2产品授权范围\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.2.1我们仅授予您和/或您孩子可撤销的、有限的、不可转让及非排他性的使用授权。\n    不得对我们产品或产品运行过程中释放到任何计算机终端内存中的数据，及产品运行过程中客户端与服务器端的交互数据进行复制，更改，修改，挂接运行或创作任何衍生作品，形式包括但不限于使用插件，外挂或非经授权的第三方工具/服务接入我们产品和相关服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.2.2 保留权利：未明示授权的其他一切权利仍归我们所有，用户使用其他权利时须另外取得书面同意。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.3一般条款和使用许可 \n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.3.1用户使用许可\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议的服务条款约束您与我们之间的关系，涉及您对我们提供服务的使用。 “您”是指您作为父母，法定监护人或经授权的学校教师，以及您授予其使用服务权利的孩子或学生。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您是父母或法定监护人，并且允许您的孩子使用我们的服务，则表示您同意接受这些本协议的约束。如果您是学校老师或管理者，并允许学生使用这些服务，则表示您已被授权，在遵守《个人信息保护法》和有关家庭教育法规的前提下，同意接受本协议的约束。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.3.2 服务条款和隐私政策\n    "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("b", [
        _vm._v(
          "使用我们的服务时，视为您：（1）同意接受这些服务条款和条件的约束； （2）同意我们的隐私政策； （3）同意接受我们在我们的产品内及网站上随时发布的其他政策和法律声明的约束。这些具有法律约束力的服务条款将阐明您使用我们服务的权利，义务和限制。"
        ),
      ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您不同意本协议（包含这些服务条款和我们的隐私政策），请立即停止使用我们的服务。仅在您同意并遵守所有适用国家法律和本协议的情况下，您才有权继续使用我们的服务。我们要求您阅读并同意我们的隐私政策，并鼓励您向我们提出任何相关问题。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.3.3 限制使用的用户\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您未满18周岁，则必须有父母，法定监护人或经授权的学校教师授权才能同意本服务条款。父母只能为自己的孩子注册一个家长帐户。父母应确认，孩子在使用其与账户相关联的服务时均有具有法定监护权的父母或监护人同意。父母，法定监护人应确认，使用者已经阅读并接受了本服务条款和隐私政策，并完全有能力理解和遵守本协议中规定的服务条款，条件，义务，责任，描述和保证。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.3.4 服务条款更新\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们保留因我们的需要及慎重考虑后，随时通过在我们的网站上或应用内发布经修订的服务条款来更改，修改，添加或删除本服务条款某些部分的权利。这些条款的最后修改日期可以在本协议的末尾找到。您可能还会收到电子邮件通知，或应用内通知您任何重大更改的消息。通过继续使用我们的任何服务，您将被视为接受了服务条款的更改。\n    如果您是学校管理者或教育工作者，如果"
      ),
      _c("b", [_vm._v("《服务条款》或《隐私政策》")]),
      _vm._v(
        "发生重大变化而影响到您须使用的数据，我们将通过电子邮件将这种变化通知您帐户登记的电子邮件地址。\n    如果您是父母或法定监护人，则在更改与未满14周岁儿童的个人信息有关的隐私政策时，我们将通过电子邮件通知您需要您明确同意的信息。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您在任何时候不同意我们服务条款或隐私政策的最新版本，请您立即停止使用我们的服务，且您使用服务的许可应立即终止。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4注册及订阅\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.4.1账号信息\n    创建或更换家长账号时，我们会要求您提供某些个人信息，其中可能包括"
      ),
      _c("b", [
        _vm._v("您的姓名/昵称，电子邮件地址或手机号，城市，国家/地区。"),
      ]),
      _vm._v(
        "您的个人信息将按照我们的隐私政策进行保存和使用。您同意您将向我们提供真实，准确和完整的信息，并在信息发生变化后立即更新该信息。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.4.2 注册账号\n    用户在使用我们的服务前需要注册一个使用账号。鉴于不同产品提供的账号注册方式不同，将使用"
      ),
      _c("b", [_vm._v("电子邮箱，手机号码")]),
      _vm._v(
        "进行注册。请您使用正确及可正常使用的电子邮箱及手机号码进行注册。我们可以根据用户需求或产品需要，对账号注册和绑定方式进行变更，并通过网站、官方公众号发布公告，且无须事先通知用户。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本信息将按照我们的隐私政策进行保存和使用。您同意您将向我们提供真实，准确和完整的信息，并在信息发生变化后立即更新该信息。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    1.4.3 通知信息\n    您注册和使用本服务时，即表示同意埃努码公司和我们的订阅服务商使用您帐户对应的电子通讯信息。您同意来自埃努码公司或我们的订阅服务商以符合法律要求的此类通信，例如以邮件、短信形式向您提供该通知。您同意以电子方式接收促销信息，优惠，调查和要求。如果您不再希望接收非事务性通知，则可以随时使用电子邮件底部的链接，或短信回复”T“来取消。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4.4 个人使用注意事项\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    根据您的同意和持续遵守本服务条款以及您支付的订阅服务费，埃努码公司授予您非排他性，不可转让，可撤销的有限使用权利，该有限使用权利须遵守第1节限制，您才可以在自己的内部，个人和非商业目的前提下访问和使用我们的服务。根据中国法律法规，您确认并承诺您是使用都都产品与/或服务的儿童监护人，或者已满18周岁但仍有兴趣使用都都产品的成年用户。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4.5 订阅\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们的服务可能以一次性订阅，每月定期订阅，试用期或免费访问向您提供。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您可以通过移动应用程序商店或其他第三方在线分销商（应用商店和第三方分销商统称为“订阅提供者”，通过订阅提供商购买的此类订阅称为“第三方订阅”），或直接通过我们的网站购买订阅。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您选择购买第三方订阅，您明确同意授权我们的订阅提供商向您收取与所选服务相关的费用（“服务费”）。通过订阅提供商进行的购买受此类订阅提供商的条款和条件的约束。任何与第三方订阅相关的问题均应提交给订阅提供商。如果与订阅提供商发生争议，您应自行承担解决争议的风险。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您保证，您使用特定信用卡或银行卡，支票付款或其他埃努码公司认可的支付方式是经过授权的，并且您向我们，订购提供商或我们指定的任何第三方的所有信息都是真实准确的（包括但不限于您的信用卡号和有效期）；您同意支付所有费用，包括任何适用的营业税。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    您有责任支付与您选择购买的服务相关的服务费。\n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4.6 每月定期订阅\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    除非您取消订阅，否则将首先在订阅建立之时或订阅提供的试用期结束时以月度方式收取订阅费用。请注意，计费周期可能会有所不同。请注意，您的结算时间可能会改变（即，如果您的付款方式出现问题，例如信用卡过期）。在建立订阅之前，您应确认适用的计费政策。您可以随时通过订阅提供商访问您的帐户来更新您的付款信息。如果信用卡被拒绝，则订阅提供商将取消您的定期订阅并通过电子邮件发送通知给您。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您可以随时直接通过订阅提供者取消订阅。请注意，您必须在下个月的订阅续订前取消其订阅，以避免收取下个月的订阅费。如果您取消订阅，则取消将在当前的每月订阅期结束时生效。从您的设备中删除我们的移动应用程序不会取消定期订阅；您将继续被收取费用。与通过订阅提供商购买的订阅的付款有关的任何问题均应直接提交给订阅提供商。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4.7退款\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您购买了第三方订阅，您应直接向订阅提供商询问退款事宜。其他订阅，您可通过第1.7条所述方式联系我们提出申请，我们将在核对您的身份与订阅信息后，在符合法律法规的条件下为您提供相应服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.4.8 免费试用或免费访问\n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    任何免费访问或试用服务仍受本服务条款的约束。\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们可能随时更改，暂停或阻止的此类服务部分，恕不另行通知。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.5 用户授权和使用规范\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    通过访问或使用任何我们的服务（包括使用任何我们的移动应用程序或浏览任何埃努码公司网站），即表示您接受并同意这些服务条款。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.5.1 用户授权及许可限制\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    严格禁止违反以下许可限制的任何使用服务，继续使用可能会导致您这些服务条款授予的有限许可被立即撤销，并可能使您承担法律责任。您企图破坏或干扰服务的任何企图，包括破坏或操纵任何埃努码公司服务的合法运营，均违反埃努码公司政策，并且可能违反刑法和民法。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    您理解并同意在任何情况下都不会：\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    · 从事埃努码公司认为与服务的精神或意图相抵触的任何行为，包括但不限于规避或操纵这些服务条款；"
      ),
      _c("br"),
      _vm._v(
        "\n    · 有意或无意地将服务用于与任何适用法律或法规的违反或关联；"
      ),
      _c("br"),
      _vm._v(
        "\n    · 干扰或试图干扰本服务的正常运行，或以本服务条款未明确允许的任何方式连接或使用本服务；"
      ),
      _c("br"),
      _vm._v("\n    · 违反任何计算机网络的安全性，或破解任何安全性加密代码；"),
      _c("br"),
      _vm._v(
        "\n    · 非法律允许情况下，进行逆向工程，反编译，反汇编，解密或以其他方式尝试获取用于提供服务的任何基础软件或其他知识产权的源代码，或使用未经明确许可的任何信息，或通过未经许可的方法从服务中获取任何信息；"
      ),
      _c("br"),
      _vm._v(
        "\n    · 复制，修改或分发任何服务或埃努码公司的版权或商标的权利或内容，或使用任何方法复制或分发服务的内容（除本服务条款明确允许之外的）。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.5.2 用户使用规范\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    根据《中华人民共和国保守国家秘密法》《中华人民共和国著作权法》《中华人民共和国计算机信息系统安全保护条例》《计算机软件保护条例》《信息网络传播权保护条例》《中华人民共和国网络安全法》等有关计算机及互联网规定的法律、法规，用户不得利用产品账户或我们提供的服务进行如下行为：\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    · 提交/发布虚假信息，盗用他人头像或资料，冒充，利用他人名义的行为；"
      ),
      _c("br"),
      _vm._v("\n    · 强制，诱导其他用户关注，点击链接页面或分享信息的；"),
      _c("br"),
      _vm._v("\n    · 虚构事实，隐瞒真相以误导，欺骗他人的；"),
      _c("br"),
      _vm._v("\n    · 利用技术手段进行违法行为的；"),
      _c("br"),
      _vm._v("\n    · 利用产品账户或本服务从事任何违法犯罪活动的；"),
      _c("br"),
      _vm._v(
        "\n    · 制作，发布与以上行为相关的方法，工具，或对此类方法，工具进行运营或传播，无论这些行为是否为商业目的；"
      ),
      _c("br"),
      _vm._v(
        "\n    · 其他违反法律法规规定，侵犯用户及我们合法权益，干扰产品正常运营或未明示授权的行为。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.5.3 暂停/终止/注销帐户与服务\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    在不限制任何其他补救措施的情况下，您可以通过第1.7条所述方式联系我们提出申请，来暂停、取消暂停或删除已注册的帐户。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您可以直接在都都产品内通过访问“家长”按钮，在“用户存档”的“我的账号”-“账号管理”下方的“注销服务”来注销账号。\n    请您知悉，您注销账号的行为是不可逆的，一旦您的账号被注销，我们将不再收集您和/或您孩子的个人信息，也将立即终止为您您提供都都产品与/或服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如您违反了1.5条用户授权和使用规范的任何一条规定，则我们有权制止账户包括禁止您的访问服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.6 账号管理\n    "),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.6.1应用和服务\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    服务可能包括受版权，商标和版权保护的知识产权（包括但不限于任何内容，游戏，标题，计算机代码，概念，艺术品，动画，声音，音乐作品，视听效果和操作方法）。美国和/或其他国家/地区的其他知识产权法（以下简称“知识产权法”）。此类知识产权法通常禁止未经授权复制，分发或展示所有文本，图形图像，音乐，声音采样和其他受保护的材料。违反适用的知识产权法可能会导致民事和/或刑事处罚。  Enuma保留与服务有关的所有权利，包括但不限于所有知识产权或其他专有权，除非做出第三方归属。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您承认并同意，本服务条款中的任何内容均不具有将服务或任何部分的任何版权，商标，服务标记，商标名称或其他专有权的所有权转让给您或任何人的任何部分的效力。您不得做任何与该标题不符的行为或与之相似的行为。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.6.2个人和学校账户\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您承认并同意您不拥有账户所有权或其他财产权益，并且您进一步承认并同意，账户中和账户中的所有权利将永远属于并确保Enuma，Inc.的权益。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    学校账户应在合同期结束后的合理时间后，申请取消在教师信息中心内收集的任何可识别个人身份的学生数据。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    通常，我们会在收到您的取消或删除请求或在收费服务的订购期或合同期结束时，终止账户服务。任何使用Enuma创建的帐户或提供的服务将被视为处于活动状态的账户，我们将重新计时。我们也保留终止180天内无活动状态帐户服务的权利，并在回收无活动状态账户前通过有效的联系方式告知您。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    1.7客户服务\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    有关我们服务的客户服务查询，您可以访问我们的帮助中心常见问题获得解答。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您在查看常见问题解答后仍无法解决问题，请通过以下方式与我们联系："
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    （1）拨打客服电话：（86+）18810316494"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    （2）联系官方客服QQ：2179916770（工作时间：每日9：00-21：30）"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    （3）联系官方微信TodoServer01或微信公众号都都APP，在线咨询人工客服"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    （4）发送邮件至215032956@qq.com或2179916770@qq.com。"),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们将在15个工作日内处理并答复您的投诉与意见。如无法响应您的请求，我们会在法律规定的最大时限要求内，向您发送通知并解释原因。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    对于通过订阅提供商购买的与您的订阅有关的客户服务事宜，请直接联系订阅提供商。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第二章 服务的变更，中断与终止")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们将不断增加学习内容和游戏并改善我们的服务；因此，服务将随着时间的推移而变化。我们可能会暂停或中止任何部分的服务，或者我们可能会引入新功能或对某些功能施加限制，或限制对服务部分的访问。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    Enuma保留在任何时候通过在我们的网站上发布经修订的服务条款（如有必要）来更改，修改，添加或删除本服务条款部分内容的权利。本服务条款最后一次修改的日期见本协议最后。此外，如有任何重大变化，如服务减少或取消，我们将通过电子邮件或服务中的消息功能通知您。发生重大变更时，如果您不同意，您可以在接收通知消息的三十天时间内通知我们取消您的服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如果您在任何时间不同意我们当前版本的服务条款或隐私政策的任何部分，您必须立即停止使用我们的服务。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    如发生下列任何一情形，我们有权变更，中断与终止向您提供的免费服务或收费服务：\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    · 根据法律规定用户应提交真实信息，而用户提供的个人资料不真实，或与注册时信息不一致并无法提供合理证明的；"
      ),
      _c("br"),
      _vm._v("\n    · 用户违反相关法律法规或本协议的约定；"),
      _c("br"),
      _vm._v("\n    · 按照法律法规或有权机关的要求；"),
      _c("br"),
      _vm._v("\n    · 出于安全的原因或其他必要的情形。"),
      _c("br"),
      _vm._v(
        "\n    且确属于用户造成的，需由用户承担责任。我们无需对用户或任何第三方承担任何责任。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第三章 法律责任与免责声明")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    3.1法律责任\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.1.1 如果我们发现或收到他人举报或投诉用户违反本协议约定的，我们有权不经通知即随时对相关内容，包括但不限于用户资料，使用记录进行审查和删除，并视情节轻重对违规账号处以包括但不限于警告，账号封禁，设备封禁，功能封禁的处罚，且通知用户处理结果。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.1.2 因违反本协议及隐私政策导致账号被封禁的用户，可向我们官方客服：QQ2179916770或微信公众号“都都APP”人工客服提交申诉，我们将对申诉进行审查，并提供合理的解决方案。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.1.3 用户理解并同意，我们有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应承担因此而产生的一切法律责任。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.1.4 用户理解并同意，因用户违反本协议约定，导致或产生的任何第三方主张的任何索赔，要求或损失，包括合理的律师费，用户应当赔偿Enuma与合作公司，关联公司，并使之免受损害。您同意，本段规定将在您的帐户或服务终止后继续有效。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    3.2免责声明\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.1 用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见，不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水，地震，瘟疫流行和风暴等以及社会事件如战争，动乱，政府行为等。出现上述情况时，我们将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，我们及合作单位在法律允许的范围内免责。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.2 服务以其包含的所有内容和游戏均按“原样”和“可用”的进行分发和传输，无任何明示或暗示的承诺担保，包括但不限于对适销性或特定用途适用性，非侵权担保，或对服务的使用将不受干扰或无差错。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本服务同大多数互联网服务一样，受包括但不限于用户原因，网络服务质量，社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如用户下载安装的其他软件或访问的其他网站中含有木马病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭受损失和骚扰。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    对于因用户使用这些服务或这些服务中包含的信息和材料而导致的系统卡顿，延迟，不准确，错误或遗漏，Enuma不承担任何责任。如有上述情况，全部风险均由您承担。您可以通过第1.7条所述方式联系我们就埃努码提供的服务提出申请，我们将在15日内根据您的情况为您提供处理方案。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.3 用户理解并确认，本服务存在因不可抗力，计算机病毒或黑客攻击，系统不稳定，用户所在位置，用户关机以及其他任何技术，互联网络，通信线路原因等造成的服务中断或不能满足用户要求的风险，属于用户操作造成的，因此导致的用户或第三方任何损失，需由用户承担责任。我们不承担赔偿责任。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.4 用户理解并确认，在使用本服务过程中可能存在来自任何他人的包括误导性，欺骗性，威胁性，诽谤性，令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息，以及伴随该信息的侵权行为，因用户个人恶意参与导致的用户或第三方的任何损失，我们不承担赔偿责任。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.5 用户理解并确认，我们需要定期或不定期地对产品或网站进行检修或维护，如因此类情况而造成服务在合理时间内的中断，我们无需为此承担赔偿责任，但我们应事先进行通告。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.6 都都数学/都都英语及Enuma的其他软件产品，依据法律法规，本协议约定获得处理违法违规或违约内容的权利，该权利不构成产品的义务或承诺，产品不能保证及时发现违法违规或违约行为或进行相应处理。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    3.2.7 在适用法律的最大允许范围内，我们仅承担本协议明确约定的直接责任。除本协议另有约定外，在任何情况下，Enuma对于任何及所有索赔，损害，损失和诉讼因由（无论是合同，侵权还是其他方式），所承担的赔偿责任总额不超过我们因向您提供服务而收取的费用总额（如果有）。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第四章 争议解决")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    4.1 一般约定\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您和Enuma同意，我们将根据本协议第四章内容或Enuma的相关规定，解决因本协议或服务引起的法律或经济上的任何索赔或争议（以下统称“索赔”），您将另有书面形式的同意。在采用这些索赔方法之前，我们强烈建议您首先直接与我们联系。我们将考虑通过替代的纠纷解决程序，例如调解或仲裁，作为诉讼的替代方法解决纠纷中的合理要求。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    4.2 法律选择\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议的效力，解释及纠纷的解决，适用于中华人民共和国法律。用户需同意您与Enuma之间的协议和关系受中华人民共和国法律的管辖，不考虑其法律冲突条款。\n    您同意，无论任何法令或法律有何相反规定，因使用本服务或服务条款而产生的或与之相关的任何索赔或诉讼原因，将在该索赔或诉讼原因产生后3年内提交。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    4.3 仲裁\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    因本协议或服务引起的或与之相关的任何法律争议或索赔（不包括我们或您因知识产权所有权或侵权而采取的法律行动，包括收回或收取损害赔偿金，或获得任何禁令），应根据司法部门的商业仲裁规则进行具有约束力的保密仲裁解决。任何此类争议或主张均应单独进行仲裁，并且不得与任何其他方的任何索赔或争议合并在任何仲裁中。任何此类争议或主张提起的仲裁申请，均应提交【中国国际经济贸易仲裁委员会】，按照申请仲裁时该会现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方均有约束力。各方应平等承担仲裁产生的仲裁费和费用，且各方应自行承担各自的律师费。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    尽管有仲裁争议的前述义务，但各方均有权随时从任何具有管辖权的法院寻求禁令或其他法律救助。就本协议的而言，当事双方同意在中华人民共和国广东省深圳市南山区法院享有专属管辖权和审判地。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本协议中的语言应被解释为其公平含义，而不是严格地支持或反对任何一方。解释本协议时，不应使用任何解释规则，以解决对起草方不利的歧义。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第五章 可分割性")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    您和Enuma同意，如果仲裁员或具有法律管辖权的法院将本协议的任何部分全部或部分视为不合法或不可执行，则该部分条款仅适用于该管辖区，仅在该认定范围内无效或无法执行的范围内无效，而不影响其在任何其他方式或司法管辖权的有效性或可执行性，也不影响本协议的其余条款，本协议应继续具有全部效力。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c("h2", [_vm._v("第六章 其他说明")]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n    6.1 转让限制\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    未经Enuma事先书面同意，您不得转让或委托服务条款或隐私政策项下的任何权利或义务，您未经授权的任何转让和委托均无效。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    6.2 协议的法律效力\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本服务条款视为您和Enuma的最终解释条款，取代双方之前有关本服务达成的所有理解，无论是电子，口头或书面的，或者您和我们之间就本服务达成的习惯，惯例，政策或先例。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    6.3 标题\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本服务条款中的章节标题仅是为了方便起见，没有法律或合同效力。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v("\n    6.4 通知\n    "),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    我们可能会通过在官方微信公众号“都都APP”上发帖通知您，或在我们的应用程序中通过电子邮件或消息弹窗来通知您。 您根据本服务条款发出或要求您提供的所有信息，均应为书面形式发送至： 2179916770@qq.com。您在未遵守本节通知规定的情况下，提供的任何信息均不具有法律效力。\n    "
      ),
      _c("br"),
      _c("br"),
      _vm._v(
        "\n    本版发布日期：2024年10月29日\n    生效日期：2024年10月29日\n"
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }